import { gcsApi } from 'config/axios';

/**
 * @param {String} eventType
 * @param {Object} [parameters]
 */
export function postGarminEvent(eventType, parameters) {
    if (!eventType) {
        throw new Error('eventType is required');
    }

    /** AnalyticsEvent
     * https://api.gcs.garmin.com/client-analytics/swagger-ui/index.html#/garmin-analytics-controller/analyticsEvent */
    const GarminEvent = {
        eventType,
        timestamp: new Date().getTime(),
        parameters
    };
    return gcsApi.post('/client-analytics/analytics/garmin/event', [GarminEvent], {
        headers: { 'X-Garmin-Paired-App-Version': window.URL_BUST_VALUE }
    });
}
